<template>

    <form method="POST" :action="route">
        <input type="hidden" name="_token" :value="token">
            <table class="abc-table mx-auto text-center" style="width:100%;">
                <thead class="abc-title-table">
                    <tr style="border-bottom: 3px solid #1e1e1e; font-size: 12px!important;">
                        <th style="width: 24%; vertical-align: middle; color: #1e1e1e;" class="step1">Classe d'actif</th>
                        <th class="py-3" style="width: 24%; vertical-align: middle; color: #1e1e1e;">Secteur</th>
                        <th style="width: 24%; vertical-align: middle; color: #1e1e1e;">Titres</th>
                        <th style="width: 24%; vertical-align: middle; color: #1e1e1e;">Score climatique</th>
                        <th style="width: 4%; vertical-align: middle;"></th>
                    </tr>
                </thead>
                <tbody >
                    <tr v-for="(project, index) in projs" :key="index" style="border-bottom: 1px solid rgba(30, 30, 30, .1);">
                        <input type="hidden"
                            :name="'form[' + index + '][id]'"
                            :value="project.id ">
                        <td style="vertical-align: middle; width:24%;">
                            <select
                                class="form-control-4"
                                style="font-size:11px; width: 100%; text-transform: capitalize;"
                                v-model="project.asset_class">
                                <option value="null" disabled>Selectionner la classe d'actifs</option>
                                <option v-for="asset_class in assets" :key="asset_class.id" :value="asset_class">{{ asset_class.name }}</option>
                            </select>

                            <input
                                v-if="project.asset_class != null"
                                type="hidden"
                                style="font-size:11px;"
                                :name="'form[' + index + '][asset_class_id]'"
                                :value="project.asset_class.id ">
                        </td>
                        <td class="py-3 px-2" style="vertical-align: middle; width:24%;">
                            <select
                                class="form-control-4"
                                style="font-size:11px; width:100%; text-transform:capitalize;"
                                v-model="project.sector">
                                <option value="null" disabled>Selectionner le secteur</option>
                                <option v-for="sector in filteredSector(project)" :key="sector.id" :value="sector" >{{ sector.name }} </option>
                            </select>

                            <input
                                v-if="project.sector != null"
                                type="hidden"
                                :name="'form[' + index + '][client_category_id]'"
                                :value="project.sector.id ">
                        </td>
                        <td class="px-2" style="vertical-align: middle; width:24%;">
                            <select
                                    class="form-control-4"
                                    style="font-size:11px; width:100%; text-transform:capitalize;"
                                    v-model="project.security">
                                    <option value="null" disabled>Selectionner le titre</option>
                                    <option v-for="security in filteredSecurity(project)" :key="security.id" :value="security">{{ security.name }} {{ security.esg_score_aggregated }}</option>
                            </select>

                            <input type="hidden"
                                v-if="project.security != null"
                                style="font-size:11px; text-transform:capitalize;"
                                :name="'form[' + index + '][service_id]'"
                                :value="project.security.id ">
                        </td>
                        <td class="px-2" style="vertical-align: middle; width:24%;">
                            <div v-if="project.security != null" class="font-weight-bold pb-2" style="color: rgb(187, 134, 252)">
                                {{ project.security.esg_score_aggregated }}
                            </div>
                            <div v-else class="font-weight-bold pb-2" style="color: rgb(187, 134, 252)">
                                {{ project.esg_score_aggregated }}
                            </div>
                        </td>
                        <td v-if="project.security != null">
                            <div v-if="project.security.is_lookthrough">
                                <button class="btn-alt-2" v-b-modal="modalId(project.security.isin)">
                                    Décomposition
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-plus-circle ml-1" style= "margin-bottom: 2px;" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                    </svg>
                                </button>
                                <b-modal
                                    :title="'La décomposition de votre allocation'+project.security.name"
                                    class="modal fade alt-list" :id="'modal' + project.security.isin"
                                    tabindex="-1"
                                    role="dialog"
                                    size="xl"
                                    aria-labelledby="alternatives"
                                    aria-hidden="true"
                                    :header-bg-variant="headerBgVariant"
                                    :header-text-variant="headerTextVariant"
                                    :body-bg-variant="bodyBgVariant"
                                    :body-text-variant="bodyTextVariant"
                                    :footer-bg-variant="footerBgVariant"
                                    :footer-text-variant="footerTextVariant"
                                    ok-only
                                    >
                                    <div style="display: contents;">
                                        <table class="myfotable-dark">
                                            <colgroup>
                                                <col style="width: 30%;">
                                                <col style="width: 10%;">
                                                <col style="width: 20%;">
                                                <col style="width: 10%;">
                                                <col style="width: 10%;">
                                                <col style="width: 10%;">
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th style="text-align: left;">Titre</th>
                                                    <th>ISIN</th>
                                                    <th>Secteur</th>
                                                    <th>Pays</th>
                                                    <th>Devise</th>
                                                    <th>Poids</th>
                                                    <th>Score climatique</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(alternative, index) in project.security.security_lookthrough" :key="index">
                                                    <div v-if="alternative.name === 'myfo rocks'" style="display: contents;" id="random">
                                                        <td style="font-weight: bold; color: rgb(187, 134, 252); text-align: left;">
                                                            <div class='blurry'>
                                                                {{ alternative.security.name }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class='blurry-white'>
                                                                {{ alternative.security.isin }}
                                                            </div>
                                                        </td>
                                                        <td>{{ alternative.security.sector }}</td>
                                                        <td>{{ alternative.security.country }}</td>
                                                        <td>{{ alternative.security.currency }}</td>
                                                        <td style="font-weight: bold;">{{ Math.round(alternative.weight*10000)/100 }} %</td>
                                                        <td>{{ alternative.security.esg_score }}</td>
                                                    </div>
                                                    <div v-else style="display: contents;">
                                                        <td style="font-weight: bold; color: rgb(187, 134, 252); text-align: left;">{{ alternative.name }}</td>
                                                        <td>{{ alternative.security.isin }}</td>
                                                        <td>{{ alternative.security.sector }}</td>
                                                        <td>{{ alternative.security.country }}</td>
                                                        <td>{{ alternative.security.currency }}</td>
                                                        <td style="font-weight: bold;">{{ Math.round(alternative.weight*10000)/100 }} %</td>
                                                        <td>{{ alternative.security.esg_score }}</td>
                                                    </div>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </b-modal>
                            </div>
                        </td>
                        <td v-else>
                        </td>
                        <td style="vertical-align: middle; width:4%;">
                            <button
                                style="font-size: 32px!important; text-align:center; vertical-align:middle; color:red;"
                                v-if="!project.disabled"
                                type="button"
                                class="close"
                                aria-label="Close"
                                v-on:click="projs.splice(projs.indexOf(project), 1)">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        <div class="row justify-content-center" style="padding-bottom: 20px;">
            <div class="col-md-6 px-4 my-3">
                <div class="mr-auto" style="width: max-content;">
                    <button type="button" class="btn-abc" style="padding:10px;" v-on:click="addRaw">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-plus-circle mr-2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                        </svg>
                        Ajouter un titre
                    </button>
                </div>
            </div>
            <div class="col-md-6 px-4 my-3">
                <div class="ml-auto" style="width: max-content;">
                    Score total = {{ total }}
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        props: [
            'securities',
            'asset_classes',
            'sectors',
            'token',
            'route',
        ],

        data() {
            return {
                form: [],
                secs:[],
                sects:[],
                projs:[],
                assets: [],
                variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark'],
                headerBgVariant: 'info',
                headerTextVariant: 'light',
                bodyBgVariant: 'dark',
                bodyTextVariant: 'dark',
                footerBgVariant: 'info',
                footerTextVariant: 'dark'
            }
        },

        mounted() {
            this.securities.forEach(security =>
            {
                this.secs.push(security)
                if (!this.assets.find(element => element.id == security.asset_class.id))
                {
                    this.assets.push(security.asset_class);
                }
                if (!this.sects.find(element => element.id == security.sector.id))
                {
                    this.sects.push(security.sector);
                }
            });

            this.assets.sort((a, b) =>
                {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                },
            );

            this.secs.sort((a, b) =>
                {
                    if (a.esg_score_aggregated > b.esg_score_aggregated)
                        return -1;
                    if (a.esg_score_aggregated < b.esg_score_aggregated)
                        return 1;
                    return 0;
                },
            );

            this.sects.sort((a, b) =>
                {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                },
            );
            this.addRaw();
            this.addRaw();
            this.addRaw();

        },

        computed: {
            total()
            {
                var tot = 0;
                this.projs.forEach(project =>
                {
                    if (project.security != null)
                    {
                        tot += project.security.esg_score_aggregated
                    }
                });
                return tot;
            }
        },

        methods: {
            filteredSecurity(project){
                if (project.asset_class != null && project.sector != null)
                {
                    return this.secs.filter(s => s.sector.name === project.sector.name).filter(s => s.asset_class.name === project.asset_class.name);
                }
                else
                {
                    return [];
                }
            },

            filteredSector(project){
                if (project.asset_class != null)
                {
                    var sector = [];
                    this.secs.filter(s => s.asset_class.name === project.asset_class.name).forEach(security =>
                    {
                        if (!sector.find(element => element.id == security.sector.id))
                        {
                            sector.push(security.sector);
                        }
                    });
                    return sector;
                }
            },

            modalId(i) {
            return 'modal' + i;
            },

            addRaw(){
                this.projs.push(
                {
                    id: null,
                    asset_class: null,
                    sector: null,
                    security: null,
                    esg_score_aggregated: 0,
                });
            }
        }
    }

</script>